import { DND_GRID_AREA_MODULE_ELEMENT_ID_PREFIX } from '../constants';
export function buildBackgroundImageClassname(nodeId, breakpointName, layerIndex) {
  return `background-image-${nodeId}-${breakpointName}-${layerIndex}`;
}
export function buildBackgroundColorClassname(nodeId, breakpointName, layerIndex) {
  return `background-color-${nodeId}-${breakpointName}-${layerIndex}`;
}
export function buildBackgroundGradientClassname(nodeId, breakpointName, layerIndex) {
  return `background-gradient-${nodeId}-${breakpointName}-${layerIndex}`;
}
export function buildSectionClassname(nodeId) {
  return `dnd-grid-section-${nodeId}`;
}
export function buildSectionContentClassname(nodeId) {
  return `section-${nodeId}-content`;
}
export function buildContainerClassname(nodeId) {
  return `dnd-grid-container-${nodeId}`;
}
export function buildBackgroundLayerClassname(nodeId, breakpointName) {
  return `background-layers-${nodeId}-${breakpointName}`;
}
export function buildModuleWrapperId(nodeId) {
  return `${DND_GRID_AREA_MODULE_ELEMENT_ID_PREFIX}${nodeId}`;
}